import React from 'react';
import PropTypes from 'prop-types';

export const ProfileImage = ({ profilePicture }) => {
  if (profilePicture) {
    return <img src={profilePicture} className="profile-image" />;
  }
  return <></>;
};

ProfileImage.propTypes = {
  profilePicture: PropTypes.string
};

ProfileImage.defaultProps = {
  profilePicture: ''
};
